import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { INGREDIENT_SPECIAL_CASES_QUERY } from '../graphql/queries'
import { FETCH_INGREDIENT_SPECIAL_CASES } from '../redux/action-types'
import { cleanupFetchIngredientSpecialCases } from '../redux/actions'

const useIngredientSpecialCasesQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchIngredientSpecialCases)

  const { isLoading, error, data, latestEvent } = useSelector(
    store => store.ingredients.ingredientSpecialCases,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(
        INGREDIENT_SPECIAL_CASES_QUERY,
        {},
        dispatch,
        FETCH_INGREDIENT_SPECIAL_CASES,
      ),
    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, latestEvent }
}

export default useIngredientSpecialCasesQuery
